var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50003 0.0183105C7.12707 0.0183105 6.76938 0.166468 6.50566 0.430191C6.24194 0.693914 6.09378 1.0516 6.09378 1.42456V6.11206H1.40628C1.03332 6.11206 0.675634 6.26022 0.411911 6.52394C0.148188 6.78766 3.05176e-05 7.14535 3.05176e-05 7.51831C3.05176e-05 7.89127 0.148188 8.24896 0.411911 8.51268C0.675634 8.7764 1.03332 8.92456 1.40628 8.92456H6.09378V13.6121C6.09378 13.985 6.24194 14.3427 6.50566 14.6064C6.76938 14.8702 7.12707 15.0183 7.50003 15.0183C7.87299 15.0183 8.23068 14.8702 8.4944 14.6064C8.75812 14.3427 8.90628 13.985 8.90628 13.6121V8.92456H13.5938C13.9667 8.92456 14.3244 8.7764 14.5882 8.51268C14.8519 8.24896 15 7.89127 15 7.51831C15 7.14535 14.8519 6.78766 14.5882 6.52394C14.3244 6.26022 13.9667 6.11206 13.5938 6.11206H8.90628V1.42456C8.90628 1.0516 8.75812 0.693914 8.4944 0.430191C8.23068 0.166468 7.87299 0.0183105 7.50003 0.0183105Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.73529e1fc221ac142353232a58efa93d.svg";
export { ForwardRef as ReactComponent };